import { IElement } from "../../../entities/src/element";
import { Modelable } from "../../../entities/src/modelable";

export class Element implements Modelable<IElement> {
    constructor(public data: IElement) {}
}
